/* eslint-disable no-unused-vars */
export const getOverallScoreStyle = (_, { palette = {} }) => ({
  recOverallScoreContainer: {
    minWidth: 1000,
    display: 'flex',
    marginTop: 0,
    marginLeft: 0,
    marginBottom: 0,
    alignItems: 'center',
    position: 'relative',
    background: palette.neutralLighterAlt,
    paddingTop: 16,
    paddingLeft: 32,
    paddingBottom: 16,
    paddingRight: 22,
    borderBottom: `solid 1px ${palette.neutralQuaternaryAlt}`,
    '& .with-history-button': {
      '& #button-download': {
        right: 74,
      },
    },
    '& #button-download': {
      backgroundColor: 'transparent',
      border: 'none',
      color: palette.themeDarkAlt,
      padding: 'unset',
      height: 'fit-content',
      minWidth: 'unset',
      top: 30,
      right: 22,
      position: 'absolute',
    },
    '& .recommendation-history-item': {
      margin: 'unset',
      top: 'unset',
      right: 22,
      position: 'absolute',
    },
    '& .helpbutton': {
      color: `${palette.neutralPrimary} !important`,
      fontSize: 16,
      marginRight: 82,
      marginLeft: 'unset',
    },
    '& .helpbutton:before': {
      top: 2,
      content: '"\\E9CE"',
      position: 'relative',
      fontFamily: 'MsAds MDL2 Assets',
    },
    '& #zero-overall-score': {
      borderBottom: `1px dashed ${palette.themePrimary}`,
      cursor: 'pointer',
    },
    '& .auto-apply-container': {
      position: 'absolute',
      right: '75px',
    },
    '& .auto-apply-container.with-download-button': {
      right: '124px',
    },
  },
  scoreLabel: {
    fontWeight: 600,
    fontSize: 18,
    marginRight: 6,
  },
  scoreValue: {
    fontWeight: 600,
    fontSize: 32,
    color: palette.themePrimary,
  },
  scoreBarChartContainer: {
    position: 'relative',
    marginLeft: 15,
  },
  betaTagContainer: {
    position: 'absolute',
    display: 'inline-block',
    marginTop: '-11px',
    marginLeft: '-86px',
  },
});
